<template>
     <div class="md:inline-flex md:space-x-6 mt-4 flex flex-wrap">
        <div class="md:w-fit mb-4 md:mb-0" :class="smartlocks ? 'w-full' : 'w-1/2 pr-4 md:pr-0'" v-if="product.brand_id == 1">
            <div
                class="flex items-center group h-full cursor-pointer hover:border-gray-400 transition-all text-gray-600 border rounded-lg px-5 py-2 shadow space-x-4"
                @click="addRimlock"
            >
                <fa :icon="['fal', 'plus']" class="h-4 w-4" />
                <vue-picture
                    :image="{ src: asset('img/config/oplegslot.webp'), origin_src: asset('img/config/oplegslot.png') }"
                    :width="50"
                    :height="35"
                />
                <span class="group-hover:text-gray-900">Oplegslot</span>
            </div>
        </div>

        <div class="md:w-fit mb-4 md:mb-0" :class="smartlocks ? 'w-full' : 'w-1/2 pr-4 md:pr-0'">
            <div
                class="flex items-center group h-full cursor-pointer hover:border-gray-400 transition-all text-gray-600 border rounded-lg px-5 py-2 shadow space-x-4"
                @click="addPadlock"
            >
                <fa :icon="['fal', 'plus']" class="h-4 w-4" />
                <vue-picture
                    :image="{ src: asset('img/config/hangslot-abus.webp'), origin_src: asset('img/config/hangslot-abus.png') }"
                    :width="50"
                    :height="42"
                />
                <span class="group-hover:text-gray-900">Hangslot</span>
            </div>
        </div>

        <div class="md:w-fit mb-4 md:mb-0" :class="smartlocks ? 'w-full' : 'w-1/2 pr-4 md:pr-0'" v-if="product.brand_id == 1">
            <div
                v-if="smartlocks"
                class="flex items-center group cursor-pointer hover:border-gray-400 transition-all text-gray-600 w-full md:w-fit border rounded-lg px-5 py-2 shadow space-x-4"
                @click="showModalSmartlock"
            >
                <fa :icon="['fal', 'plus']" class="h-4 w-4" />
                <vue-picture
                    :image="{ src: asset('img/config/smartlock.webp'), origin_src: asset('img/config/smartlock.png') }"
                    :width="50"
                    :height="35"
                />
                <span class="group-hover:text-gray-900">Smartlock</span>
            </div>
        </div>
    </div>
</template>

<script setup>
let emit = defineEmits(['showModalSmartlock', 'addPadlock', 'addRimlock']);

const props = defineProps({
    smartlocks: Boolean,
    clean: Boolean,
    product: Object,
});

function showModalSmartlock() {
    emit('showModalSmartlock', false);
}

function addPadlock() {
    emit('addPadlock', false);
}

function addRimlock() {
    emit('addRimlock', false);
}
</script>
